//const baseURL = 'http://localhost:9000';
const baseURL = 'https://www.lineaduran.com';

export default baseURL;
